import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Layout from "../components/Layout";

export default function ContactPage() {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    // Basic honeypot check
    if (form.current.honeypot.value) {
      console.log("Bot detected.");
      return;
    }

    setStatus("Sending...");

    emailjs
      .sendForm(
        "service_72hqluq",
        "template_4mkro4m",
        form.current,
        "22ucUfcNHc4B3CcJX"
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatus("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          console.error(error.text);
          setStatus("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <Layout>
      {/* Hero */}
      <section className="hero">
        <div className="hero-text">
          <h1>Get in touch with our team today</h1>
          <p>
            At TearabyteSS, despite our focus on technology, we are a people-first company.
            You’ll always speak to a real person when you contact us, never an automated system.
          </p>
          <p className="email">
            <a href="mailto:contact@tearabytess.co.uk" className="conLink">
              contact@tearabytess.co.uk
            </a>
            <br />
            <a href="tel:+447541264513" className="conLink">
              +44 75412 64513
            </a>
          </p>
        </div>
      </section>

      {/* Contact Form */}
      <section className="intro-section">
        <h2>Contact Form</h2>
        <p>Fill out the form below and we’ll get straight back to you:</p>
        <form ref={form} onSubmit={sendEmail} className="contact-form">
          {/* Honeypot */}
          <div style={{ display: "none" }}>
            <input type="text" name="honeypot" />
          </div>

          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input required type="text" id="name" name="name" />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input required type="email" id="email" name="email" />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea required id="message" name="message" rows="5"></textarea>
          </div>

          <button type="submit" className="contactLink">
            Submit
          </button>

          {status && <p style={{ marginTop: "1rem" }}>{status}</p>}
        </form>
      </section>
    </Layout>
  );
}
